import warehouse from '@/api/warehouse'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return warehouse.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store (context, data) {
    return warehouse.store(data)
  },

  update (context, data) {
    return warehouse.update(data)
  },
  destroy (context, id) {
    return warehouse.destroy(id)
  },

  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await warehouse.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
